import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "Common/assets/styles/datepicker.scss?vue&type=style&index=0&lang=scss&external"
import "Common/assets/styles/themes/light/theme.scss?vue&type=style&index=1&lang=scss&external"

const __exports__ = script;

export default __exports__